import { InjectionToken } from '@angular/core';

/**
 * What a step may ask of the wizard around it. Provided by `WizardPage` through the
 * injector the step is created with, so a step needs no inputs and no outputs — it either
 * ignores this entirely and lets the footer button drive, or it takes over.
 */
export interface WizardStepHost {
  /** Completes this step: on to the next one, or close if it was the last. */
  advance(): void;
  /**
   * Completes this step and closes the wizard right away, for a step that hands the user
   * over to a flow of its own. Resolves only once the completion is on disk.
   *
   * Steps still queued behind this one stay queued and appear at the next app start.
   */
  handOver(): Promise<void>;
}

export const WIZARD_STEP_HOST = new InjectionToken<WizardStepHost>('WIZARD_STEP_HOST');
